<p-table #dt styleClass="p-datatable-responsive-demo" [value]="surveyList" [loading]="!surveyList" [globalFilterFields]="app.keys(surveyList)">
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1 me-2">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
			<div class="ms-auto">
				<p-button pRipple styleClass="p-button-raised p-button-primary m-2" (click)="add()">
					<ng-template pTemplate="content">
						<div class="d-flex justify-content-center">
							<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1 me-2"></fa-icon>
							Add
						</div>
					</ng-template>
				</p-button>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="name">
				<div class="d-flex w-100">
					Name
					<p-sortIcon field="name"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="name" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="created">
				<div class="d-flex w-100">
					Created
					<p-sortIcon field="created"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="date" field="created" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="viewed">
				<div class="d-flex w-100">
					View Count
					<p-sortIcon field="viewed"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="number" field="viewed" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="answered">
				<div class="d-flex w-100">
					Response Count
					<p-sortIcon field="answered"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="number" field="answered" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr (click)="selectSurvey(rec.sk)">
			<td>
				{{ rec.name }}
			</td>
			<td>
				{{ app.moment(rec.created).format("L LT") }}
			</td>
			<td>{{ rec.viewed }}</td>
			<td>{{ rec.answered }}</td>
		</tr>
	</ng-template>
</p-table>
